import {Button} from "antd";
import useUserContext from "../../hooks/useUserContext";
import {updateCheckoutIgnore} from "../../api/updateCheckoutIgnore";
import useToast from "../../hooks/useToast";
import {ToastSkin} from "../../context/ToastContext";

interface RecoverableCheckoutTooltipContentProps {
    checkoutId: number;
    reFetch?: () => void;
}

export const RecoverableCheckoutTooltipContent = ({ checkoutId, reFetch }: RecoverableCheckoutTooltipContentProps) => {
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const onClick = async () => {
        if(selectedDomain) {
            const response = await updateCheckoutIgnore(selectedDomain, checkoutId, true);
            if(response?.data?.errorMessage || !response?.data) {
                showToast({ skin: ToastSkin.error, text: 'Failed to update ignored status for the checkout you requested' });
            } else {
                showToast({ skin: ToastSkin.approval, text: 'Checkout status was updated' });
                reFetch && reFetch();
            }
        }
    }

    return (
        <div>
            <div>This checkout is recoverable, but you can choose to ignore it if you don’t want to initiate the recovery process.</div>
            <Button type="default" size="small" className="tooltip-button" onClick={onClick}>Skip Recovery</Button>
        </div>
    )
}